import { shortDate, units } from "@/lib/format"
import type { Sales, SalesWindow } from "../types"
import Section from "./Section"

function SalesRow({ label, value, note }: { label: string; value: string; note?: string | null }) {
  return (
    <div className="flex items-baseline justify-between gap-3 text-sm text-foreground">
      <span>
        {label}
        {note && <span className="ml-2 text-xs">{note}</span>}
      </span>
      <span className="tabular-nums">{value}</span>
    </div>
  )
}

// Units in this market. Days no published plan covers are not counted; a
// window the plan ends inside says so.
export default function SalesSection({ sales, today }: { sales: Sales; today: string }) {
  const planned = (w: SalesWindow) => (w.planned === null ? "No plan" : units(w.planned))
  const note = (w: SalesWindow) => (w.plan_ends_on ? `plan ends ${shortDate(w.plan_ends_on, today)}` : null)

  return (
    <Section title="Sales" aside="Units, this market">
      <SalesRow label="This month's plan" value={planned(sales.this_month)} note={note(sales.this_month)} />
      <SalesRow label="Sold this month so far" value={units(sales.this_month.actual)} />
      <SalesRow label="Plan, next 30 days" value={planned(sales.next_30_days)} note={note(sales.next_30_days)} />
      <SalesRow label="Plan, next 90 days" value={planned(sales.next_90_days)} note={note(sales.next_90_days)} />
    </Section>
  )
}
